import { getBestOperatorGeohashes, getCapacityGeohashes, getCustomOperatorGeohashes } from "../services/api/mapGeohashes.api";
import { getBestOptrIBSMapData, getOptrIBSMapData } from "../services/api/mapIBS.api";
import { filterEdotcoSiteTowers, filterOperatorSiteTowers, filterProposedEdotcoTowers } from "../services/api/siteService";

export const SupplyType = {
  RSRP: "RSRP",
  DOWNLOAD: "Download",
  UPLOAD: "Upload",
  DATA_RECEIVED: "Data_Received",
  DATA_TRANSMIT: "Data_Transmit",
  DATA_TRANSCEIVED: "Data_Transceived",
};

export const geohashMiddle = { // used to calc middle of a geohash
  7: 0.00068665,
  8: 0.00016615,
  9: 0.00002165
};

export const bestSupplyTypeKeyMapper = {
  RSRP: "best_rsrp",
  Upload: "best_upload",
  Download: "best_download",
  Data_Received: "data_received",
  Data_Transmit: "data_transmitted",
  Data_Transceived: "data_transceived",
};

export const bestTopTypeKeyMapper = {
  best_dbm: "b_dbm",
  best_down: "b_down",
  best_up: "b_up",
  best_rsrq: "b_rsrq",
  best_sinr: "b_sinr",
  best_ms: "b_ms",
  data_received: "data_received",
  data_transceived: "data_transceived",
  data_transmitted: "data_transmitted",
};

export const bestOpTypeKeyMapper = {
  l_rsrp: "b_dbm",
  l_down: "b_down",
  l_up: "b_up",
  l_rsrq: "b_rsrq",
  l_sinr: "b_sinr",
  ms: "b_ms",
  data_received: "data_received",
  data_transceived: "data_transceived",
  data_transmitted: "data_transmitted",
};


export const bestSupplyTypeMapper = {
  RSRP: (data) =>
    !data.best_rsrp || data.best_rsrp == "No Data" ? "noData" : data.best_rsrp,
  Upload: (data) =>
    !data.best_upload || data.best_upload == "No Data"
      ? "noData"
      : data.best_upload,
  Download: (data) =>
    !data.best_download || data.best_download == "No Data"
      ? "noData"
      : data.best_download,
  Data_Received: (data) =>
    !data.data_received || data.data_received == "No Data"
      ? "noData"
      : data.data_received,  
  Data_Transmit: (data) =>
    !data.data_transmitted || data.data_transmitted == "No Data"
      ? "noData"
      : data.data_transmitted,     
  Data_Transceived: (data) =>
    !data.data_transceived || data.data_transceived == "No Data"
      ? "noData"
      : data.data_transceived, 
};

export const supplyLvlMapper = {
  RSRP: "rsrp_level",
  Upload: "upload_level",
  Download: "download_level",
};

export const supplyDataMapper = {
  Data_Received: "data_received",
  Data_Transceived:"data_transceived",
  Data_Transmit:"data_transmitted",
};

export const supplyLvlInfoMapper = {
  rsrp_level: "SUPPLY_OP_RSRP",
  upload_level: "SUPPLY_OP_UP",
  download_level: "SUPPLY_OP_DOWN",
};

export const supplyLvlLegendTitleMapper = {
  RSRP: "Signal Strength (dBm)",
  Upload: "Upload (Mbps)",
  Download: "Download (Mbps)",
};

const supplyLvlLegendMetaTxtMap = {
  "5G": {
    Excellent: {
      RSRP: "> -90",
      Upload: ">= 20",
      Download: ">= 100",
    },
    Good: {
      RSRP: "-90 to -105",
      Upload: "10 to 20",
      Download: "50 to 100",
    },
    Fair: {
      RSRP: "-105 to -120",
      Upload: "2 to 10",
      Download: "10 to 50",
    },
    Poor: {
      RSRP: "=< -120",
      Upload: "< 2",
      Download: "< 10",
    },
  },
  "4G": {
    Excellent: {
      RSRP: "> -85",
      Upload: ">= 10",
      Download: ">= 50",
    },
    Good: {
      RSRP: "-85 to -100",
      Upload: "5 to 10",
      Download: "10 to 50",
    },
    Fair: {
      RSRP: "-100 to -110",
      Upload: "1 to 5",
      Download: "5 to 10",
    },
    Poor: {
      RSRP: "=< -110",
      Upload: "< 1",
      Download: "< 5",
    },
  },
  "3G": {
    Excellent: {
      RSRP: "> -70",
      Upload: ">= 1",
      Download: ">= 5",
    },
    Good: {
      RSRP: "-70 to -85",
      Upload: "0.5 to 1",
      Download: "2 to 5",
    },
    Fair: {
      RSRP: "-85 to -95",
      Upload: "0.2 to 0.5",
      Download: "1 to 2",
    },
    Poor: {
      RSRP: "=< -95",
      Upload: "< 0.2",
      Download: "< 1",
    },
  },
};

export const supplyLvlLegend = (type, connectionType) => [
  {
    markerType: "colorBox",
    text: "Excellent",
    metaText: supplyLvlLegendMetaTxtMap[connectionType]["Excellent"][type],
    colorCode: "excellent",
  },
  {
    markerType: "colorBox",
    text: "Good",
    metaText: supplyLvlLegendMetaTxtMap[connectionType]["Good"][type],
    colorCode: "good",
  },
  {
    markerType: "colorBox",
    text: "Fair",
    metaText: supplyLvlLegendMetaTxtMap[connectionType]["Fair"][type],
    colorCode: "fair",
  },
  {
    markerType: "colorBox",
    text: "Poor",
    metaText: supplyLvlLegendMetaTxtMap[connectionType]["Poor"][type],
    colorCode: "poor",
  },
  ...connectionType === '5G' ? [{
    markerType: "colorBox",
    text: "No 5G",
    colorCode: "no_5g",
  }] : [],
  ...connectionType === '4G' ? [{
    markerType: "colorBox",
    text: "No 4G",
    colorCode: "no_4g",
  }] : [],
  {
    markerType: "colorBox",
    text: "No Coverage",
    colorCode: "nc",
  },
  {
    markerType: "colorBox",
    text: "No Data",
    colorCode: "no_data",
  },
];

export const TooltipType = {
  BEST: "best",
  NORMAL: "normal",
};

export const DemandScoreTypes = {
  FINAL: "Final",
  SAMPLE: "Sample",
  DEVICE: "Device",
  AFFLUENCE: "Affluence",
};

export const DemandScoreLabels = {
  FINAL: "Demand Score",
  SAMPLE: "Sample Score",
  DEVICE: "Device Score",
  AFFLUENCE: "Affluence Level",
};

export const demandScoreMapper = {
  Final: "final_score",
  Sample: "sample_score",
  Device: "device_score",
  Affluence: "level",
};

export const demandLegendGradient = [
  { color: "#B3B3B3", pos: 0 },
  { color: "#E8D166", pos: 0.5 },
  { color: "#D64550", pos: 1 },
];

export const demandTooltipTitle = {
  Final: "Final Score",
  Sample: "Sample Score",
  Device: "Device Score",
};

export const demandTooltipImg = {
  Final: "finalscore",
  Sample: "samplescore",
  Device: "devicescore",
};

export const SiteType = {
  EdotcoSite: "edotco",
  Edotco_SiteRef: "edotco_siteref",
  OperatorSite: "operator",
  Proposed: "proposed"
};

export const gMapClusterImages =
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"; // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder

export const WEB_MAP_API_TOPIC = "WEB_MAP_API_TOPIC";

export const boxTolerance = { // boxTolerance based on zoom lvl
  12: 0.08,
  13: 0.05,
  14: 0.015,
  15: 0.01,
  16: 0.007,
  17: 0.0065,
  18: 0.006,
  19: 0.0005,
  20: 0.0004,
}

export const supplyCustOpFiltersMap = [
  { key: "Excellent", value: "Excellent" },
  { key: "Good", value: "Good" },
  { key: "Fair", value: "Fair" },
  { key: "Poor", value: "Poor" },
  { key: "No 4G", value: "No 4G" },
  { key: "No 5G", value: "No 5G" },
  { key: "NC", value: "No Coverage" },
];

export const EdotcoSiteIconLegend = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM11.5 15C11.5 10.3056 15.3056 6.5 20 6.5C24.6944 6.5 28.5 10.3056 28.5 15C28.5 17.8529 27.093 20.3772 24.9419 21.9164C24.2682 22.3985 23.3312 22.2432 22.8491 21.5695C22.367 20.8957 22.5224 19.9588 23.1961 19.4767C24.5939 18.4765 25.5 16.8441 25.5 15C25.5 11.9624 23.0376 9.5 20 9.5C16.9624 9.5 14.5 11.9624 14.5 15C14.5 16.8441 15.4061 18.4765 16.8039 19.4767C17.4776 19.9588 17.633 20.8958 17.1509 21.5695C16.6688 22.2432 15.7318 22.3985 15.0581 21.9164C12.907 20.3772 11.5 17.8529 11.5 15ZM16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM20 14.5C19.7239 14.5 19.5 14.7239 19.5 15C19.5 15.2761 19.7239 15.5 20 15.5C20.2761 15.5 20.5 15.2761 20.5 15C20.5 14.7239 20.2761 14.5 20 14.5ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z"
        fill={`${color}`}
      />
    </svg>
  );
};

export const UploadIcon = ({ bgColor = "#f0f0f0",strokeColor="#777", style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="36"
      viewBox="0 0 60 36"
      style={style}
    >
      <g id="Group_1674" data-name="Group 1674" transform="translate(-24 -523)">
        <rect
          id="Rectangle_2414"
          data-name="Rectangle 2414"
          width="60"
          height="36"
          rx="4"
          transform="translate(24 523)"
          fill={bgColor}
        />
        <g id="Group_1603" data-name="Group 1603" transform="translate(26 525)">
          <path
            id="Path_3788"
            data-name="Path 3788"
            d="M6,28.005v7.1H26V28"
            transform="translate(0 -9.104)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
          <path
            id="Path_3789"
            data-name="Path 3789"
            d="M24.9,28.552,19.448,23,14,28.552"
            transform="translate(-3.448 -17)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
          <path
            id="Path_3790"
            data-name="Path 3790"
            d="M23.992,20.648V6"
            transform="translate(-7.996 0)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
        </g>
        <path
          id="Path_3837"
          data-name="Path 3837"
          d="M0,4.581,4.83,0,9.411,4.581"
          transform="translate(73 542.92) rotate(180)"
          fill="none"
          stroke={strokeColor}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3.5"
        />
      </g>
    </svg>
  );
};

export const DownloadIcon = ({
  bgColor = "#f0f0f0",
  strokeColor = "#777",
  style,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="36"
      viewBox="0 0 60 36"
      style={style}
    >
      <g id="Group_3155" data-name="Group 3155" transform="translate(-24 -523)">
        <rect
          id="Rectangle_2414"
          data-name="Rectangle 2414"
          width="60"
          height="36"
          rx="4"
          transform="translate(24 523)"
          fill={bgColor}
        />
        <g id="Group_1603" data-name="Group 1603" transform="translate(26 525)">
          <path
            id="Path_3788"
            data-name="Path 3788"
            d="M6,28.005v7.1H26V28"
            transform="translate(0 -9.104)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
          <path
            id="Path_3789"
            data-name="Path 3789"
            d="M24.9,28.552,19.448,23,14,28.552"
            transform="translate(35.448 43.648) rotate(180)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
          <path
            id="Path_3790"
            data-name="Path 3790"
            d="M23.992,20.648V6"
            transform="translate(39.996 26.648) rotate(180)"
            fill="none"
            stroke={strokeColor}
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3.5"
          />
        </g>
        <path
          id="Path_3837"
          data-name="Path 3837"
          d="M0,4.581,4.83,0,9.411,4.581"
          transform="translate(73 542.92) rotate(180)"
          fill="none"
          stroke={strokeColor}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3.5"
        />
      </g>
    </svg>
  );
};

export const DocumentTextIcon = ({ style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
      />
    </svg>
  );
};


export const PinMarkerIcon = ({ fill = "#006f35",stroke='none', style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="11.2"
      height="16"
      viewBox="0 0 11.2 16"
    >
      <g
        id="Group_2832"
        data-name="Group 2832"
        transform="translate(-785.5 -189.477)"
      >
        <path
          id="Path_4146"
          data-name="Path 4146"
          d="M18.8,4H12.4L14,5.2l-1.6,5.2S10,12,10,13.6h4L15.6,20l1.6-6.4h4c0-1.6-1.6-2.733-2.4-3.2L17.2,5.2Z"
          transform="translate(775.5 185.477)"
          fill={fill}
          stroke={stroke}
          strokeWidth={0.2}
        />
      </g>
    </svg>
  );
};

export const TriangleMarkerIcon = ({fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14.029"
      viewBox="0 0 16 14.029"
    >
      <g
        id="Group_2833"
        data-name="Group 2833"
        transform="translate(-692.015 -375.744)"
      >
        <path
          id="Path_4147"
          data-name="Path 4147"
          d="M10.792,6.381a.779.779,0,0,1,1.349,0l7.22,12.47a.779.779,0,0,1-.674,1.17H4.246a.779.779,0,0,1-.674-1.17Z"
          transform="translate(688.549 369.752)"
          fill={fill}
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
};

export const CircleMarkerIcon = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="20"
      width="20"
    >
      <circle cx="12" cy="12" r="10" fill={fill} />
    </svg>
  );
};

export const RectangleMarkerIcon = ({ fill="#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect
        id="Rectangle_2782"
        data-name="Rectangle 2782"
        width="16"
        height="16"
        rx="2"
        fill={fill}
      />
    </svg>
  );
};

export const TowerMarkerIcon = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="15.4"
      height="17.207"
      viewBox="0 0 15.4 17.207"
    >
      <g
        id="Group_2834"
        data-name="Group 2834"
        transform="translate(-5.5 -3.293)"
      >
        <path
          id="Path_4148"
          data-name="Path 4148"
          d="M6,44H20.4"
          transform="translate(0 -24)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4149"
          data-name="Path 4149"
          d="M17,20h5.4"
          transform="translate(-6.502 -9.6)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4150"
          data-name="Path 4150"
          d="M17.158,20h3.859l1.158,9.263H16Z"
          transform="translate(-5.887 -9.263)"
          fill="none"
          stroke={fill}
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4151"
          data-name="Path 4151"
          d="M19,9l.772,4.245h2.316L22.859,9"
          transform="translate(-7.73 -3.07)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4152"
          data-name="Path 4152"
          d="M22.175,7.088,21.017,5.93,19.088,4l-1.93,1.93L16,7.088"
          transform="translate(-5.887)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4153"
          data-name="Path 4153"
          d="M37,5.158,38.158,4"
          transform="translate(-18.53)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4154"
          data-name="Path 4154"
          d="M9.158,5.158,8,4"
          transform="translate(-1.228)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4155"
          data-name="Path 4155"
          d="M37,19l1.158,1.158"
          transform="translate(-18.53 -8.983)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4156"
          data-name="Path 4156"
          d="M9.158,19,8,20.158"
          transform="translate(-1.228 -8.983)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4157"
          data-name="Path 4157"
          d="M38,13h1.544"
          transform="translate(-19.144 -5.4)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4158"
          data-name="Path 4158"
          d="M7.544,13H6"
          transform="translate(0 -5.4)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4159"
          data-name="Path 4159"
          d="M18,28h4.631"
          transform="translate(-7.116 -14.4)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4160"
          data-name="Path 4160"
          d="M17,36h5.4"
          transform="translate(-6.502 -19.087)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4161"
          data-name="Path 4161"
          d="M29,20l1.158,9.263"
          transform="translate(-13.771 -9.263)"
          fill="none"
          stroke={fill}
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4162"
          data-name="Path 4162"
          d="M17.158,20,16,29.263"
          transform="translate(-5.987 -9.263)"
          fill="none"
          stroke={fill}
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const LocationMarkerIcon = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="16.927"
      height="16.927"
      viewBox="0 0 16.927 16.927"
    >
      <g
        id="Group_2835"
        data-name="Group 2835"
        transform="translate(-3.5 -3.5)"
      >
        <path
          id="Path_4163"
          data-name="Path 4163"
          d="M19.185,10.371A3.185,3.185,0,1,0,16,7.185,3.185,3.185,0,0,0,19.185,10.371Z"
          transform="translate(-7.222)"
          fill="none"
          stroke={fill}
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4164"
          data-name="Path 4164"
          d="M24,20v7.167"
          transform="translate(-12.037 -9.629)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4165"
          data-name="Path 4165"
          d="M8.778,32H7.185L4,36.778H19.927L16.741,32H15.149"
          transform="translate(0 -16.851)"
          fill="none"
          stroke={fill}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export const PolygonLine = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="3"
      viewBox="0 0 31 3"
    >
      <path
        id="Path_4166"
        data-name="Path 4166"
        d="M17232.033,12098.448h28"
        transform="translate(-17230.533 -12096.948)"
        fill="none"
        stroke={fill}
        stroke-linecap="round"
        stroke-width="3"
      />
    </svg>
  );
};

export const PolygonDottedLineOne = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="3"
      viewBox="0 0 28 3"
    >
      <path
        id="Path_4167"
        data-name="Path 4167"
        d="M17232.033,12098.448h28"
        transform="translate(-17232.033 -12096.948)"
        fill="none"
        stroke={fill}
        stroke-width="3"
        stroke-dasharray="1 1"
      />
    </svg>
  );
};

export const PolygonDottedLineTwo = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="3"
      viewBox="0 0 28 3"
    >
      <path
        id="Path_4168"
        data-name="Path 4168"
        d="M17232.033,12098.448h28"
        transform="translate(-17232.033 -12096.948)"
        fill="none"
        stroke={fill}
        stroke-width="3"
        stroke-dasharray="2 2"
      />
    </svg>
  );
};

export const PolygonDottedLineThree = ({ fill = "#006f35", style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="3"
      viewBox="0 0 28 3"
    >
      <path
        id="Path_4169"
        data-name="Path 4169"
        d="M17232.033,12098.448h28"
        transform="translate(-17232.033 -12096.948)"
        fill="none"
        stroke={fill}
        stroke-width="3"
        stroke-dasharray="4 4"
      />
    </svg>
  );
};

export const ColorPickerIcon = ({ style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="18.434"
      height="18.435"
      viewBox="0 0 18.434 18.435"
    >
      <g
        id="color-picker--color-colors-design-dropper-eye-eyedrop-eyedropper-painting-picker"
        transform="translate(0.026 0.008)"
      >
        <path
          id="Subtract"
          d="M7.315,5.063,2.641,9.736A3.472,3.472,0,0,0,1.5,12.181a8.156,8.156,0,0,0,.2,1.694L.839,16.033c-.287.723.8,1.815,1.528,1.528l2.122-.891a8.656,8.656,0,0,0,1.656.208,3.556,3.556,0,0,0,2.569-1.17l4.62-4.62"
          fill="none"
          stroke="#006f35"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.6"
        />
        <path
          id="Union"
          d="M7.518,8.1,5.382,10.236"
          fill="none"
          stroke="#006f35"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.6"
        />
        <path
          id="Union_2"
          d="M16.256,2.145a4.609,4.609,0,0,0-6.525,0l-.746.747-.223-.207a1.163,1.163,0,0,0-1.646-.07q-.163.155-.318.318a1.167,1.167,0,0,0,.07,1.648c.6.652,1.641,1.754,3.378,3.493s2.837,2.785,3.487,3.383a1.163,1.163,0,0,0,1.646.07q.163-.155.318-.318a1.167,1.167,0,0,0-.07-1.648l-.119-.13.749-.75A4.628,4.628,0,0,0,16.256,2.145Z"
          fill="none"
          stroke="#006f35"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.6"
        />
      </g>
    </svg>
  );
};

export const OperatorSiteIconLegend = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.6232 2.03992C10.1534 1.40342 11.0993 1.31727 11.7358 1.84751C12.3723 2.37775 12.4584 3.32359 11.9282 3.96009C10.4113 5.78102 9.5 8.12006 9.5 10.6759C9.5 13.2318 10.4113 15.5708 11.9282 17.3917C12.4584 18.0282 12.3723 18.9741 11.7358 19.5043C11.0993 20.0345 10.1534 19.9484 9.6232 19.3119C7.67388 16.9719 6.5 13.959 6.5 10.6759C6.5 7.39278 7.67388 4.3799 9.6232 2.03992ZM28.2642 1.84751C28.9007 1.31727 29.8466 1.40342 30.3768 2.03992C32.3261 4.3799 33.5 7.39278 33.5 10.6759C33.5 13.959 32.3261 16.9719 30.3768 19.3119C29.8466 19.9484 28.9007 20.0345 28.2642 19.5043C27.6277 18.9741 27.5416 18.0282 28.0718 17.3917C29.5887 15.5708 30.5 13.2318 30.5 10.6759C30.5 8.12006 29.5887 5.78102 28.0718 3.96009C27.5416 3.32359 27.6277 2.37775 28.2642 1.84751ZM24.4208 5.04581C25.0573 4.51557 26.0031 4.60171 26.5333 5.23822C27.7605 6.71132 28.5 8.60922 28.5 10.6759C28.5 12.7426 27.7605 14.6405 26.5333 16.1136C26.0031 16.7501 25.0573 16.8362 24.4208 16.306C23.7843 15.7758 23.6981 14.8299 24.2284 14.1934C25.0231 13.2394 25.5 12.0153 25.5 10.6759C25.5 9.33649 25.0231 8.11244 24.2284 7.15838C23.6981 6.52188 23.7843 5.57604 24.4208 5.04581ZM13.4667 5.23822C13.9969 4.60171 14.9427 4.51557 15.5792 5.04581C16.2157 5.57605 16.3019 6.52188 15.7716 7.15838C14.9769 8.11244 14.5 9.33649 14.5 10.6759C14.5 12.0153 14.9769 13.2394 15.7716 14.1934C16.3019 14.8299 16.2157 15.7758 15.5792 16.306C14.9427 16.8362 13.9969 16.7501 13.4667 16.1136C12.2395 14.6405 11.5 12.7426 11.5 10.6759C11.5 8.60922 12.2395 6.71132 13.4667 5.23822ZM16.5 10.6759C16.5 8.74291 18.067 7.17591 20 7.17591C21.933 7.17591 23.5 8.74291 23.5 10.6759C23.5 12.6089 21.933 14.1759 20 14.1759C18.067 14.1759 16.5 12.6089 16.5 10.6759ZM20 10.1759C19.7239 10.1759 19.5 10.3998 19.5 10.6759C19.5 10.952 19.7239 11.1759 20 11.1759C20.2761 11.1759 20.5 10.952 20.5 10.6759C20.5 10.3998 20.2761 10.1759 20 10.1759ZM18.5842 16.5045C18.7948 15.9029 19.3626 15.5 20 15.5C20.6374 15.5 21.2052 15.9029 21.4158 16.5045L28.4158 36.5045C28.5764 36.9633 28.5047 37.4715 28.2234 37.868C27.9421 38.2644 27.4861 38.5 27 38.5H25C24.6748 38.5 24.3585 38.3943 24.0986 38.1989L20 35.1173L15.9014 38.1989C15.6415 38.3943 15.3252 38.5 15 38.5H13C12.5139 38.5 12.0579 38.2644 11.7766 37.868C11.4953 37.4715 11.4236 36.9633 11.5842 36.5045L18.5842 16.5045ZM19.3142 23.5H20.6858L20 21.5406L19.3142 23.5ZM18.2642 26.5L17.2781 29.3174L20 31.3639L22.7219 29.3174L21.7358 26.5H18.2642ZM16.2381 32.2888L15.3339 34.8722L17.504 33.2406L16.2381 32.2888ZM22.496 33.2406L24.6661 34.8722L23.7619 32.2888L22.496 33.2406Z"
        fill={`${color}`}
      />
    </svg>
  );
};

// obtained from x40 svg
export const siteEdotcoTowerSvg = {
  e_co_existing:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM11.5 15C11.5 10.3056 15.3056 6.5 20 6.5C24.6944 6.5 28.5 10.3056 28.5 15C28.5 17.8529 27.093 20.3772 24.9419 21.9164C24.2682 22.3985 23.3312 22.2432 22.8491 21.5695C22.367 20.8957 22.5224 19.9588 23.1961 19.4767C24.5939 18.4765 25.5 16.8441 25.5 15C25.5 11.9624 23.0376 9.5 20 9.5C16.9624 9.5 14.5 11.9624 14.5 15C14.5 16.8441 15.4061 18.4765 16.8039 19.4767C17.4776 19.9588 17.633 20.8958 17.1509 21.5695C16.6688 22.2432 15.7318 22.3985 15.0581 21.9164C12.907 20.3772 11.5 17.8529 11.5 15ZM16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM20 14.5C19.7239 14.5 19.5 14.7239 19.5 15C19.5 15.2761 19.7239 15.5 20 15.5C20.2761 15.5 20.5 15.2761 20.5 15C20.5 14.7239 20.2761 14.5 20 14.5ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z",
  napa_new_nominals:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z M22.5843 9.64387L26.5751 10.2511C26.74 10.2773 26.8944 10.3491 27.0206 10.4585C27.1468 10.5679 27.2399 10.7104 27.2893 10.87C27.3411 11.032 27.348 11.2049 27.3092 11.3705C27.2705 11.536 27.1876 11.688 27.0693 11.8101L24.1756 14.7435L24.8591 18.9425C24.8874 19.1104 24.8691 19.2828 24.8059 19.4408C24.7428 19.5989 24.6374 19.7366 24.5012 19.8387C24.3679 19.9381 24.2089 19.9972 24.043 20.0089C23.8771 20.0206 23.7114 19.9844 23.5655 19.9047L19.9985 17.9305L16.436 19.8929C16.2893 19.9719 16.1233 20.0076 15.9571 19.9959C15.7909 19.9843 15.6315 19.9256 15.4973 19.8269C15.3616 19.7246 15.2566 19.5868 15.194 19.4287C15.1314 19.2706 15.1135 19.0984 15.1424 18.9308L15.8259 14.7317L12.9321 11.7984C12.8143 11.676 12.7317 11.524 12.6932 11.3585C12.6548 11.193 12.6618 11.0201 12.7136 10.8583C12.7627 10.6985 12.8557 10.5558 12.982 10.4464C13.1083 10.337 13.2628 10.2652 13.4279 10.2393L17.4128 9.64387L19.2021 5.8496C19.2727 5.6972 19.3853 5.56816 19.5269 5.47773C19.6684 5.3873 19.8328 5.33925 20.0007 5.33925C20.1687 5.33925 20.3331 5.3873 20.4746 5.47773C20.6161 5.56816 20.7288 5.6972 20.7993 5.8496L22.5843 9.64387Z",
  b2s:
    "M20 1.5C12.5442 1.5 6.5 7.54416 6.5 15C6.5 19.6652 8.86758 23.7767 12.4598 26.1995C12.6604 25.8539 12.9664 25.5364 13.3134 25.3382C13.4782 25.244 13.6534 25.1713 13.8348 25.1212C13.7875 24.9391 13.7628 24.751 13.7619 24.5612C13.7604 24.228 13.8325 23.8993 13.9719 23.5984C11.2646 21.6966 9.5 18.5541 9.5 15C9.5 9.20101 14.201 4.5 20 4.5C25.799 4.5 30.5 9.20101 30.5 15C30.5 18.6427 28.6463 21.853 25.8239 23.7383C25.135 24.1985 24.9496 25.13 25.4098 25.8189C25.87 26.5077 26.8014 26.6931 27.4903 26.233C31.1105 23.8147 33.5 19.6868 33.5 15C33.5 7.54416 27.4558 1.5 20 1.5Z M20 6.5C15.3056 6.5 11.5 10.3056 11.5 15C11.5 17.8529 12.907 20.3772 15.0581 21.9164C15.2616 22.062 15.4891 22.1495 15.7209 22.1821C16.0922 22.036 16.4782 21.9297 16.8722 21.865C16.9757 21.7816 17.0698 21.6829 17.1509 21.5695C17.633 20.8958 17.4776 19.9588 16.8039 19.4767C15.4061 18.4765 14.5 16.8441 14.5 15C14.5 11.9624 16.9624 9.5 20 9.5C23.0376 9.5 25.5 11.9624 25.5 15C25.5 16.8441 24.5939 18.4765 23.1961 19.4767C22.5224 19.9588 22.367 20.8957 22.8491 21.5695C23.3312 22.2432 24.2682 22.3985 24.9419 21.9164C27.093 20.3772 28.5 17.8529 28.5 15C28.5 10.3056 24.6944 6.5 20 6.5Z M16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM19.5 15C19.5 14.7239 19.7239 14.5 20 14.5C20.2761 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.2761 15.5 20 15.5C19.7239 15.5 19.5 15.2761 19.5 15Z M24 38.5C24.4619 38.5 24.898 38.2872 25.1823 37.9231C25.4118 37.6292 25.5216 37.2631 25.4965 36.8972C24.9564 36.7521 24.447 36.5087 23.9942 36.1783L21.8666 34.6512L22.0788 35.5H17.9212L18.5497 32.9859C18.286 33.0228 18.0192 33.0415 17.7512 33.0417C16.9946 33.0423 16.2475 32.8949 15.5513 32.6102L14.5448 36.6362C14.4328 37.0843 14.5334 37.559 14.8177 37.9231C15.102 38.2872 15.5381 38.5 16 38.5H24Z M15.8971 30.5596C15.3422 30.224 14.8886 29.7442 14.5847 29.1713C14.2808 28.5984 14.1379 27.9538 14.1713 27.3062C14.1713 27.2592 14.1837 27.213 14.2073 27.1723C14.2309 27.1316 14.2648 27.0979 14.3057 27.0746C14.3465 27.0513 14.3927 27.0392 14.4398 27.0395C14.4868 27.0398 14.5329 27.0526 14.5734 27.0764L16.2488 28.0438C16.4443 28.1574 16.6768 28.1889 16.8954 28.1312C17.1141 28.0735 17.3009 27.9315 17.4148 27.7362L17.8895 26.9141C18.0016 26.7177 18.0312 26.4849 17.9719 26.2668C17.9125 26.0486 17.769 25.863 17.5728 25.7505L15.8974 24.7832C15.8564 24.7601 15.8224 24.7265 15.7986 24.6859C15.7748 24.6454 15.7622 24.5993 15.7619 24.5523C15.7617 24.5052 15.774 24.459 15.7974 24.4182C15.8208 24.3775 15.8546 24.3436 15.8953 24.3201C16.4438 23.9864 17.071 23.804 17.7129 23.7915C18.3548 23.779 18.9886 23.9368 19.5497 24.2488C20.1108 24.5609 20.5792 25.0161 20.9072 25.568C21.2352 26.12 21.4111 26.749 21.4169 27.391L27.6693 30.2203C27.9983 30.3647 28.2931 30.577 28.5344 30.8432C28.7758 31.1093 28.9583 31.4234 29.07 31.7649C29.1796 32.0996 29.2174 32.4537 29.181 32.8041C29.1446 33.1545 29.0348 33.4932 28.8586 33.7983C28.6825 34.1033 28.4441 34.3679 28.1588 34.5746C27.8736 34.7813 27.548 34.9256 27.2033 34.998C26.8522 35.072 26.4894 35.0712 26.1386 34.9954C25.7878 34.9197 25.457 34.7709 25.1676 34.5586L19.5977 30.5607C19.0326 30.8757 18.3966 31.0412 17.7497 31.0417C17.1028 31.0422 16.4666 30.8776 15.9011 30.5634L15.8971 30.5596Z M20 19.5C19.3117 19.5 18.7117 19.9684 18.5448 20.6362L18.2513 21.8103C19.0464 21.8765 19.8207 22.1111 20.5218 22.501C21.2275 22.8935 21.8386 23.432 22.3157 24.0782L21.4552 20.6362C21.2883 19.9684 20.6883 19.5 20 19.5Z",
  edotco_on_air:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM11.5 15C11.5 10.3056 15.3056 6.5 20 6.5C24.6944 6.5 28.5 10.3056 28.5 15C28.5 17.8529 27.093 20.3772 24.9419 21.9164C24.2682 22.3985 23.3312 22.2432 22.8491 21.5695C22.367 20.8957 22.5224 19.9588 23.1961 19.4767C24.5939 18.4765 25.5 16.8441 25.5 15C25.5 11.9624 23.0376 9.5 20 9.5C16.9624 9.5 14.5 11.9624 14.5 15C14.5 16.8441 15.4061 18.4765 16.8039 19.4767C17.4776 19.9588 17.633 20.8958 17.1509 21.5695C16.6688 22.2432 15.7318 22.3985 15.0581 21.9164C12.907 20.3772 11.5 17.8529 11.5 15ZM16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM20 14.5C19.7239 14.5 19.5 14.7239 19.5 15C19.5 15.2761 19.7239 15.5 20 15.5C20.2761 15.5 20.5 15.2761 20.5 15C20.5 14.7239 20.2761 14.5 20 14.5ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z",
  new_nominals:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z M22.5843 9.64387L26.5751 10.2511C26.74 10.2773 26.8944 10.3491 27.0206 10.4585C27.1468 10.5679 27.2399 10.7104 27.2893 10.87C27.3411 11.032 27.348 11.2049 27.3092 11.3705C27.2705 11.536 27.1876 11.688 27.0693 11.8101L24.1756 14.7435L24.8591 18.9425C24.8874 19.1104 24.8691 19.2828 24.8059 19.4408C24.7428 19.5989 24.6374 19.7366 24.5012 19.8387C24.3679 19.9381 24.2089 19.9972 24.043 20.0089C23.8771 20.0206 23.7114 19.9844 23.5655 19.9047L19.9985 17.9305L16.436 19.8929C16.2893 19.9719 16.1233 20.0076 15.9571 19.9959C15.7909 19.9843 15.6315 19.9256 15.4973 19.8269C15.3616 19.7246 15.2566 19.5868 15.194 19.4287C15.1314 19.2706 15.1135 19.0984 15.1424 18.9308L15.8259 14.7317L12.9321 11.7984C12.8143 11.676 12.7317 11.524 12.6932 11.3585C12.6548 11.193 12.6618 11.0201 12.7136 10.8583C12.7627 10.6985 12.8557 10.5558 12.982 10.4464C13.1083 10.337 13.2628 10.2652 13.4279 10.2393L17.4128 9.64387L19.2021 5.8496C19.2727 5.6972 19.3853 5.56816 19.5269 5.47773C19.6684 5.3873 19.8328 5.33925 20.0007 5.33925C20.1687 5.33925 20.3331 5.3873 20.4746 5.47773C20.6161 5.56816 20.7288 5.6972 20.7993 5.8496L22.5843 9.64387Z",
  newbuild_proposed:
    "M20 1.5C12.5442 1.5 6.5 7.54416 6.5 15C6.5 19.6652 8.86758 23.7767 12.4598 26.1995C12.6604 25.8539 12.9664 25.5364 13.3134 25.3382C13.4782 25.244 13.6534 25.1713 13.8348 25.1212C13.7875 24.9391 13.7628 24.751 13.7619 24.5612C13.7604 24.228 13.8325 23.8993 13.9719 23.5984C11.2646 21.6966 9.5 18.5541 9.5 15C9.5 9.20101 14.201 4.5 20 4.5C25.799 4.5 30.5 9.20101 30.5 15C30.5 18.6427 28.6463 21.853 25.8239 23.7383C25.135 24.1985 24.9496 25.13 25.4098 25.8189C25.87 26.5077 26.8014 26.6931 27.4903 26.233C31.1105 23.8147 33.5 19.6868 33.5 15C33.5 7.54416 27.4558 1.5 20 1.5Z M20 6.5C15.3056 6.5 11.5 10.3056 11.5 15C11.5 17.8529 12.907 20.3772 15.0581 21.9164C15.2616 22.062 15.4891 22.1495 15.7209 22.1821C16.0922 22.036 16.4782 21.9297 16.8722 21.865C16.9757 21.7816 17.0698 21.6829 17.1509 21.5695C17.633 20.8958 17.4776 19.9588 16.8039 19.4767C15.4061 18.4765 14.5 16.8441 14.5 15C14.5 11.9624 16.9624 9.5 20 9.5C23.0376 9.5 25.5 11.9624 25.5 15C25.5 16.8441 24.5939 18.4765 23.1961 19.4767C22.5224 19.9588 22.367 20.8957 22.8491 21.5695C23.3312 22.2432 24.2682 22.3985 24.9419 21.9164C27.093 20.3772 28.5 17.8529 28.5 15C28.5 10.3056 24.6944 6.5 20 6.5Z M16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM19.5 15C19.5 14.7239 19.7239 14.5 20 14.5C20.2761 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.2761 15.5 20 15.5C19.7239 15.5 19.5 15.2761 19.5 15Z M24 38.5C24.4619 38.5 24.898 38.2872 25.1823 37.9231C25.4118 37.6292 25.5216 37.2631 25.4965 36.8972C24.9564 36.7521 24.447 36.5087 23.9942 36.1783L21.8666 34.6512L22.0788 35.5H17.9212L18.5497 32.9859C18.286 33.0228 18.0192 33.0415 17.7512 33.0417C16.9946 33.0423 16.2475 32.8949 15.5513 32.6102L14.5448 36.6362C14.4328 37.0843 14.5334 37.559 14.8177 37.9231C15.102 38.2872 15.5381 38.5 16 38.5H24Z M15.8971 30.5596C15.3422 30.224 14.8886 29.7442 14.5847 29.1713C14.2808 28.5984 14.1379 27.9538 14.1713 27.3062C14.1713 27.2592 14.1837 27.213 14.2073 27.1723C14.2309 27.1316 14.2648 27.0979 14.3057 27.0746C14.3465 27.0513 14.3927 27.0392 14.4398 27.0395C14.4868 27.0398 14.5329 27.0526 14.5734 27.0764L16.2488 28.0438C16.4443 28.1574 16.6768 28.1889 16.8954 28.1312C17.1141 28.0735 17.3009 27.9315 17.4148 27.7362L17.8895 26.9141C18.0016 26.7177 18.0312 26.4849 17.9719 26.2668C17.9125 26.0486 17.769 25.863 17.5728 25.7505L15.8974 24.7832C15.8564 24.7601 15.8224 24.7265 15.7986 24.6859C15.7748 24.6454 15.7622 24.5993 15.7619 24.5523C15.7617 24.5052 15.774 24.459 15.7974 24.4182C15.8208 24.3775 15.8546 24.3436 15.8953 24.3201C16.4438 23.9864 17.071 23.804 17.7129 23.7915C18.3548 23.779 18.9886 23.9368 19.5497 24.2488C20.1108 24.5609 20.5792 25.0161 20.9072 25.568C21.2352 26.12 21.4111 26.749 21.4169 27.391L27.6693 30.2203C27.9983 30.3647 28.2931 30.577 28.5344 30.8432C28.7758 31.1093 28.9583 31.4234 29.07 31.7649C29.1796 32.0996 29.2174 32.4537 29.181 32.8041C29.1446 33.1545 29.0348 33.4932 28.8586 33.7983C28.6825 34.1033 28.4441 34.3679 28.1588 34.5746C27.8736 34.7813 27.548 34.9256 27.2033 34.998C26.8522 35.072 26.4894 35.0712 26.1386 34.9954C25.7878 34.9197 25.457 34.7709 25.1676 34.5586L19.5977 30.5607C19.0326 30.8757 18.3966 31.0412 17.7497 31.0417C17.1028 31.0422 16.4666 30.8776 15.9011 30.5634L15.8971 30.5596Z M20 19.5C19.3117 19.5 18.7117 19.9684 18.5448 20.6362L18.2513 21.8103C19.0464 21.8765 19.8207 22.1111 20.5218 22.501C21.2275 22.8935 21.8386 23.432 22.3157 24.0782L21.4552 20.6362C21.2883 19.9684 20.6883 19.5 20 19.5Z",
  existing:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM11.5 15C11.5 10.3056 15.3056 6.5 20 6.5C24.6944 6.5 28.5 10.3056 28.5 15C28.5 17.8529 27.093 20.3772 24.9419 21.9164C24.2682 22.3985 23.3312 22.2432 22.8491 21.5695C22.367 20.8957 22.5224 19.9588 23.1961 19.4767C24.5939 18.4765 25.5 16.8441 25.5 15C25.5 11.9624 23.0376 9.5 20 9.5C16.9624 9.5 14.5 11.9624 14.5 15C14.5 16.8441 15.4061 18.4765 16.8039 19.4767C17.4776 19.9588 17.633 20.8958 17.1509 21.5695C16.6688 22.2432 15.7318 22.3985 15.0581 21.9164C12.907 20.3772 11.5 17.8529 11.5 15ZM16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM20 14.5C19.7239 14.5 19.5 14.7239 19.5 15C19.5 15.2761 19.7239 15.5 20 15.5C20.2761 15.5 20.5 15.2761 20.5 15C20.5 14.7239 20.2761 14.5 20 14.5ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z",
  napa_nominal:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z M22.5843 9.64387L26.5751 10.2511C26.74 10.2773 26.8944 10.3491 27.0206 10.4585C27.1468 10.5679 27.2399 10.7104 27.2893 10.87C27.3411 11.032 27.348 11.2049 27.3092 11.3705C27.2705 11.536 27.1876 11.688 27.0693 11.8101L24.1756 14.7435L24.8591 18.9425C24.8874 19.1104 24.8691 19.2828 24.8059 19.4408C24.7428 19.5989 24.6374 19.7366 24.5012 19.8387C24.3679 19.9381 24.2089 19.9972 24.043 20.0089C23.8771 20.0206 23.7114 19.9844 23.5655 19.9047L19.9985 17.9305L16.436 19.8929C16.2893 19.9719 16.1233 20.0076 15.9571 19.9959C15.7909 19.9843 15.6315 19.9256 15.4973 19.8269C15.3616 19.7246 15.2566 19.5868 15.194 19.4287C15.1314 19.2706 15.1135 19.0984 15.1424 18.9308L15.8259 14.7317L12.9321 11.7984C12.8143 11.676 12.7317 11.524 12.6932 11.3585C12.6548 11.193 12.6618 11.0201 12.7136 10.8583C12.7627 10.6985 12.8557 10.5558 12.982 10.4464C13.1083 10.337 13.2628 10.2652 13.4279 10.2393L17.4128 9.64387L19.2021 5.8496C19.2727 5.6972 19.3853 5.56816 19.5269 5.47773C19.6684 5.3873 19.8328 5.33925 20.0007 5.33925C20.1687 5.33925 20.3331 5.3873 20.4746 5.47773C20.6161 5.56816 20.7288 5.6972 20.7993 5.8496L22.5843 9.64387Z",
  planned:
    "M20 1.5C12.5442 1.5 6.5 7.54416 6.5 15C6.5 19.6652 8.86758 23.7767 12.4598 26.1995C12.6604 25.8539 12.9664 25.5364 13.3134 25.3382C13.4782 25.244 13.6534 25.1713 13.8348 25.1212C13.7875 24.9391 13.7628 24.751 13.7619 24.5612C13.7604 24.228 13.8325 23.8993 13.9719 23.5984C11.2646 21.6966 9.5 18.5541 9.5 15C9.5 9.20101 14.201 4.5 20 4.5C25.799 4.5 30.5 9.20101 30.5 15C30.5 18.6427 28.6463 21.853 25.8239 23.7383C25.135 24.1985 24.9496 25.13 25.4098 25.8189C25.87 26.5077 26.8014 26.6931 27.4903 26.233C31.1105 23.8147 33.5 19.6868 33.5 15C33.5 7.54416 27.4558 1.5 20 1.5Z M20 6.5C15.3056 6.5 11.5 10.3056 11.5 15C11.5 17.8529 12.907 20.3772 15.0581 21.9164C15.2616 22.062 15.4891 22.1495 15.7209 22.1821C16.0922 22.036 16.4782 21.9297 16.8722 21.865C16.9757 21.7816 17.0698 21.6829 17.1509 21.5695C17.633 20.8958 17.4776 19.9588 16.8039 19.4767C15.4061 18.4765 14.5 16.8441 14.5 15C14.5 11.9624 16.9624 9.5 20 9.5C23.0376 9.5 25.5 11.9624 25.5 15C25.5 16.8441 24.5939 18.4765 23.1961 19.4767C22.5224 19.9588 22.367 20.8957 22.8491 21.5695C23.3312 22.2432 24.2682 22.3985 24.9419 21.9164C27.093 20.3772 28.5 17.8529 28.5 15C28.5 10.3056 24.6944 6.5 20 6.5Z M16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM19.5 15C19.5 14.7239 19.7239 14.5 20 14.5C20.2761 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.2761 15.5 20 15.5C19.7239 15.5 19.5 15.2761 19.5 15Z M24 38.5C24.4619 38.5 24.898 38.2872 25.1823 37.9231C25.4118 37.6292 25.5216 37.2631 25.4965 36.8972C24.9564 36.7521 24.447 36.5087 23.9942 36.1783L21.8666 34.6512L22.0788 35.5H17.9212L18.5497 32.9859C18.286 33.0228 18.0192 33.0415 17.7512 33.0417C16.9946 33.0423 16.2475 32.8949 15.5513 32.6102L14.5448 36.6362C14.4328 37.0843 14.5334 37.559 14.8177 37.9231C15.102 38.2872 15.5381 38.5 16 38.5H24Z M15.8971 30.5596C15.3422 30.224 14.8886 29.7442 14.5847 29.1713C14.2808 28.5984 14.1379 27.9538 14.1713 27.3062C14.1713 27.2592 14.1837 27.213 14.2073 27.1723C14.2309 27.1316 14.2648 27.0979 14.3057 27.0746C14.3465 27.0513 14.3927 27.0392 14.4398 27.0395C14.4868 27.0398 14.5329 27.0526 14.5734 27.0764L16.2488 28.0438C16.4443 28.1574 16.6768 28.1889 16.8954 28.1312C17.1141 28.0735 17.3009 27.9315 17.4148 27.7362L17.8895 26.9141C18.0016 26.7177 18.0312 26.4849 17.9719 26.2668C17.9125 26.0486 17.769 25.863 17.5728 25.7505L15.8974 24.7832C15.8564 24.7601 15.8224 24.7265 15.7986 24.6859C15.7748 24.6454 15.7622 24.5993 15.7619 24.5523C15.7617 24.5052 15.774 24.459 15.7974 24.4182C15.8208 24.3775 15.8546 24.3436 15.8953 24.3201C16.4438 23.9864 17.071 23.804 17.7129 23.7915C18.3548 23.779 18.9886 23.9368 19.5497 24.2488C20.1108 24.5609 20.5792 25.0161 20.9072 25.568C21.2352 26.12 21.4111 26.749 21.4169 27.391L27.6693 30.2203C27.9983 30.3647 28.2931 30.577 28.5344 30.8432C28.7758 31.1093 28.9583 31.4234 29.07 31.7649C29.1796 32.0996 29.2174 32.4537 29.181 32.8041C29.1446 33.1545 29.0348 33.4932 28.8586 33.7983C28.6825 34.1033 28.4441 34.3679 28.1588 34.5746C27.8736 34.7813 27.548 34.9256 27.2033 34.998C26.8522 35.072 26.4894 35.0712 26.1386 34.9954C25.7878 34.9197 25.457 34.7709 25.1676 34.5586L19.5977 30.5607C19.0326 30.8757 18.3966 31.0412 17.7497 31.0417C17.1028 31.0422 16.4666 30.8776 15.9011 30.5634L15.8971 30.5596Z M20 19.5C19.3117 19.5 18.7117 19.9684 18.5448 20.6362L18.2513 21.8103C19.0464 21.8765 19.8207 22.1111 20.5218 22.501C21.2275 22.8935 21.8386 23.432 22.3157 24.0782L21.4552 20.6362C21.2883 19.9684 20.6883 19.5 20 19.5Z",
  default:
    "M6.5 15C6.5 7.54416 12.5442 1.5 20 1.5C27.4558 1.5 33.5 7.54416 33.5 15C33.5 19.6868 31.1105 23.8147 27.4903 26.233C26.8014 26.6931 25.87 26.5077 25.4098 25.8189C24.9496 25.13 25.135 24.1985 25.8239 23.7383C28.6463 21.853 30.5 18.6427 30.5 15C30.5 9.20101 25.799 4.5 20 4.5C14.201 4.5 9.5 9.20101 9.5 15C9.5 18.6427 11.3537 21.853 14.1761 23.7383C14.865 24.1985 15.0504 25.13 14.5902 25.8189C14.13 26.5077 13.1986 26.6931 12.5097 26.233C8.88953 23.8147 6.5 19.6868 6.5 15ZM11.5 15C11.5 10.3056 15.3056 6.5 20 6.5C24.6944 6.5 28.5 10.3056 28.5 15C28.5 17.8529 27.093 20.3772 24.9419 21.9164C24.2682 22.3985 23.3312 22.2432 22.8491 21.5695C22.367 20.8957 22.5224 19.9588 23.1961 19.4767C24.5939 18.4765 25.5 16.8441 25.5 15C25.5 11.9624 23.0376 9.5 20 9.5C16.9624 9.5 14.5 11.9624 14.5 15C14.5 16.8441 15.4061 18.4765 16.8039 19.4767C17.4776 19.9588 17.633 20.8958 17.1509 21.5695C16.6688 22.2432 15.7318 22.3985 15.0581 21.9164C12.907 20.3772 11.5 17.8529 11.5 15ZM16.5 15C16.5 13.067 18.067 11.5 20 11.5C21.933 11.5 23.5 13.067 23.5 15C23.5 16.933 21.933 18.5 20 18.5C18.067 18.5 16.5 16.933 16.5 15ZM20 14.5C19.7239 14.5 19.5 14.7239 19.5 15C19.5 15.2761 19.7239 15.5 20 15.5C20.2761 15.5 20.5 15.2761 20.5 15C20.5 14.7239 20.2761 14.5 20 14.5ZM18.5448 20.6362C18.7117 19.9684 19.3117 19.5 20 19.5C20.6883 19.5 21.2883 19.9684 21.4552 20.6362L25.4552 36.6362C25.5672 37.0843 25.4666 37.559 25.1823 37.9231C24.898 38.2872 24.4619 38.5 24 38.5H16C15.5381 38.5 15.102 38.2872 14.8177 37.9231C14.5334 37.559 14.4328 37.0843 14.5448 36.6362L18.5448 20.6362ZM17.9212 35.5H22.0788L20 27.1847L17.9212 35.5Z",
};

// obtained from x40 svg
export const siteOprtTowerSvg =
  "M9.6232 2.03992C10.1534 1.40342 11.0993 1.31727 11.7358 1.84751C12.3723 2.37775 12.4584 3.32359 11.9282 3.96009C10.4113 5.78102 9.5 8.12006 9.5 10.6759C9.5 13.2318 10.4113 15.5708 11.9282 17.3917C12.4584 18.0282 12.3723 18.9741 11.7358 19.5043C11.0993 20.0345 10.1534 19.9484 9.6232 19.3119C7.67388 16.9719 6.5 13.959 6.5 10.6759C6.5 7.39278 7.67388 4.3799 9.6232 2.03992ZM28.2642 1.84751C28.9007 1.31727 29.8466 1.40342 30.3768 2.03992C32.3261 4.3799 33.5 7.39278 33.5 10.6759C33.5 13.959 32.3261 16.9719 30.3768 19.3119C29.8466 19.9484 28.9007 20.0345 28.2642 19.5043C27.6277 18.9741 27.5416 18.0282 28.0718 17.3917C29.5887 15.5708 30.5 13.2318 30.5 10.6759C30.5 8.12006 29.5887 5.78102 28.0718 3.96009C27.5416 3.32359 27.6277 2.37775 28.2642 1.84751ZM24.4208 5.04581C25.0573 4.51557 26.0031 4.60171 26.5333 5.23822C27.7605 6.71132 28.5 8.60922 28.5 10.6759C28.5 12.7426 27.7605 14.6405 26.5333 16.1136C26.0031 16.7501 25.0573 16.8362 24.4208 16.306C23.7843 15.7758 23.6981 14.8299 24.2284 14.1934C25.0231 13.2394 25.5 12.0153 25.5 10.6759C25.5 9.33649 25.0231 8.11244 24.2284 7.15838C23.6981 6.52188 23.7843 5.57604 24.4208 5.04581ZM13.4667 5.23822C13.9969 4.60171 14.9427 4.51557 15.5792 5.04581C16.2157 5.57605 16.3019 6.52188 15.7716 7.15838C14.9769 8.11244 14.5 9.33649 14.5 10.6759C14.5 12.0153 14.9769 13.2394 15.7716 14.1934C16.3019 14.8299 16.2157 15.7758 15.5792 16.306C14.9427 16.8362 13.9969 16.7501 13.4667 16.1136C12.2395 14.6405 11.5 12.7426 11.5 10.6759C11.5 8.60922 12.2395 6.71132 13.4667 5.23822ZM16.5 10.6759C16.5 8.74291 18.067 7.17591 20 7.17591C21.933 7.17591 23.5 8.74291 23.5 10.6759C23.5 12.6089 21.933 14.1759 20 14.1759C18.067 14.1759 16.5 12.6089 16.5 10.6759ZM20 10.1759C19.7239 10.1759 19.5 10.3998 19.5 10.6759C19.5 10.952 19.7239 11.1759 20 11.1759C20.2761 11.1759 20.5 10.952 20.5 10.6759C20.5 10.3998 20.2761 10.1759 20 10.1759ZM18.5842 16.5045C18.7948 15.9029 19.3626 15.5 20 15.5C20.6374 15.5 21.2052 15.9029 21.4158 16.5045L28.4158 36.5045C28.5764 36.9633 28.5047 37.4715 28.2234 37.868C27.9421 38.2644 27.4861 38.5 27 38.5H25C24.6748 38.5 24.3585 38.3943 24.0986 38.1989L20 35.1173L15.9014 38.1989C15.6415 38.3943 15.3252 38.5 15 38.5H13C12.5139 38.5 12.0579 38.2644 11.7766 37.868C11.4953 37.4715 11.4236 36.9633 11.5842 36.5045L18.5842 16.5045ZM19.3142 23.5H20.6858L20 21.5406L19.3142 23.5ZM18.2642 26.5L17.2781 29.3174L20 31.3639L22.7219 29.3174L21.7358 26.5H18.2642ZM16.2381 32.2888L15.3339 34.8722L17.504 33.2406L16.2381 32.2888ZM22.496 33.2406L24.6661 34.8722L23.7619 32.2888L22.496 33.2406Z";

export const clusterDefaultZoomLvl = 6;
export const geohashDefaultZoomLvl = 14;
export const sitesDefaultZoomLvl = 12;

export const MapTools = {
  DISTANCE: "distance",
  AREA: "area",
  CIRCLE: "circle",
  POLYGON: "polygon",
  FILE_UPLOAD: "fileUpload",
  FILE_DOWNLOAD: "fileDownload",
  UPLOAD_SITES: "uploadSites",
  UPLOAD_POLYGONS: "uploadPolygons",
  DOWNLOAD_PIN: "downloadPin",
  DOWNLOAD_PIN_MODAL: "downloadPinModal",
  DOWNLOAD_POLYGON: "downloadPolygon",
  DOWNLOAD_FROM_FILE: "downloadFromFile",
  SPLIT: "split",
  SLIDER: "slider"
};

export const DownloadModalTypes = {
  PIN: "pin",
  POLYGON: "polygon",
  UPLOAD_FILES: "uploadedFile",
};

export const EdotCoMultipleSiteIconMapper = {
  e_co_existing: "/assets/edotcoTowerGradient.svg",
  e_co_existing_2x: "/assets/edotcoTowerGradient2x.svg",
  napa_new_nominals: "/assets/newnominalmulticolor.svg",
  b2s: "/assets/newbuildmulticolor.svg",
  edotco_on_air: "/assets/edotcoTowerGradient.svg",
  new_nominals: "/assets/newnominalmulticolor.svg",
  newbuild_proposed: "/assets/newbuildmulticolor.svg",
  existing: "/assets/edotcoTowerGradient.svg",
  planned: "/assets/newnominalmulticolor.svg",
  napa_nominal: "/assets/newbuildmulticolor.svg",
  default: "/assets/edotcoTowerGradient.svg",
};

export const ToolIcons = {
  uploadIcon: UploadIcon,
  downloadIcon: DownloadIcon,
};

export const EdotCoSiteStatusLegend = {
  title: "e.co Sites Status",
  values: [
    {
      text: "e.co Existing",
      svg: <EdotcoSiteIconLegend color={"black"} />,
    },
    {
      text: "NaPA New Nominals",
      markerType: "image",
      markerImg: "/assets/newnominalblack.svg",
      imgWidth: "24px",
    },
    {
      text: "B2S",
      markerType: "image",
      markerImg: "/assets/newbuildblack.svg",
      imgWidth: "24px",
    },
  ],
};

export const formatSupplyLevel = (lvl) =>
  lvl ? lvl.replace(/(\s|-)+/g, "_").toLowerCase() : "no_data";

export const connectionTypeIconMapper = {
  ["3G"]: "/assets/three-g-grey.png",
  ["4G"]: "/assets/four-g-grey.png",
  ["5G"]: "/assets/five-g-grey.png"
};

export const connectionTypeCheckedIconMapper = {
  ["3G"]: "/assets/three-g-white.png",
  ["4G"]: "/assets/four-g-white.png",
  ["5G"]: "/assets/five-g-white.png"
};

export const IconMapper = {
  "2G": "/assets/two-g-grey.png",
  "3G": "/assets/three-g-grey.png",
  "4G": "/assets/four-g-grey.png",
  "5G": "/assets/five-g-grey.png"
};

export const CheckedIconMapper = {
  "2G": "/assets/two-g-white.png",
  "3G": "/assets/three-g-white.png",
  "4G": "/assets/four-g-white.png",
  "5G": "/assets/five-g-white.png"
};


export const connectionTypes = {
  "5G": "5G",
  "4G": "4G",
  "3G": "3G",
}

export const googleClusterImgUrl = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';

export const GEOHASH_MAX_LEN = 9;

export const SITEREF_TABLE_COL_KEYS = {
  SITE_REF: 'siteRef',
  OPRTR_OP: 'oprtr.op',
  OPRTR_BS_DWN: 'oprtr.bs_dwn',
  OPRTR_BS_rsrp: 'oprtr.bs_rsrp',
  OPRTR_BS_UPL: 'oprtr.bs_upl',
  OPRTR_BS_DEMAND: 'oprtr.bs_demand',
  OPRTR_NBR_DWN: 'oprtr.nghbr_dwn',
  OPRTR_NBR_rsrp: 'oprtr.nghbr_rsrp',
  OPRTR_NBR_UP: 'oprtr.nghbr_up',
  OPRTR_NBR_DEMAND: 'oprtr.nghbr_demand',
  OPRTR_RDS_DWN: 'oprtr.rdis_dwn',
  OPRTR_RDS_RSRP: 'oprtr.rdis_rsrp',
  OPRTR_RDS_DEMAND: 'oprtr.rdis_demand'
};

export const SEARCH_AREA_STATES = {
  INIT: "init",
  ENABLED: "enabled",
  B_C: "bbox_changed", // bounds_changed
  FETCH: "fetch"
};

export const EdotcoStatusOrder = [
  "Existing",
  "Planned",
  "NaPA Nominal",
  "Edotco-On Air",
  "NewBuild-Proposed",
  "New Nominals"
];

export const EdotcoActionOrder = [
  "Planned Colo",
  "Planned Consolidate",
  "Existing Colo",
  "NaPA Nominal",
  "B2S Colo",
  "B2S-B2S Consolidate",
  "B2S-e.co Consolidate",
  "New Nominals"
];

// common obj to maintain sort orders. Use this with sortByReference() in helpers/fuctionHelpers.js
export const DATA_ORDERS = {
  ADM: ["ADM1", "ADM2", "ADM3"],
  CT: ["5G", "4G", "3G"],
  SIG_LVL: ['Excellent', 'Good', 'Fair', 'Poor', 'No Coverage', 'No Data'],
  NET_ACTION: ["Invest to Maintain", "Selective Investment", "Invest to Defend", "Not Enough Data"],
  QUAD: ["A", "B", "C", "D", "Not Enough Data"],
  AGGR_TYPE: ["Max", "90th_Percentile", "80th_Percentile", "Mean", "Median", "Average", "50th_Percentile", "Min"],
  ATTR_TYPE: ["RSRP", "Download", "DownloadSpeed", "DownloadThroughput", "Upload", "UploadSpeed", "UploadThroughput", "RSRQ", "SINR"],
  TREND_TABS: ["Daily", "Weekly", "Monthly"]
}

export const LABEL_RENAME = {//didnt changed the values and added some 
  RSRP: "Signal Strength",
  SINR: "S/N Ratio",
  RSRQ: "Signal Quality"
}

export const ICON_MAP = {
  RSRP: "/assets/signal.png",
  Download: "/assets/download.png",
  Upload: "/assets/upload.png",
  RSRQ: "/assets/No Signal.png",
  SINR: "/assets/sinrIcon.png",
  Score: "/assets/marketShareIcon.png",
  default: "/assets/networkActionIcon.png"
}


export const UNIT_MAPPING = {
  "Upload": "Mbps",
  "Download": "Mbps",
  "RSRP": "dBm",
  "SINR": "dB",
  "RSRQ": "dB",
  "Data Received": "MB",
  "Data Transceived": "MB",
  "Data Transmitted": "MB"
};

export const DECIMAL_MAPPING = {
  "Upload": 2,
  "Download": 2,
  "RSRP": 0,
  "SINR": 0,
  "RSRQ": 0,
  "Data Received": 2,
  "Data Transceived": 2,
  "Data Transmitted": 2
};

export const STATIC_ATTRS = ["RSRP", "Upload", "Download", "SINR", "RSRQ"];

export const fileTypes = {
  SITE: "site",
  POLYGON: "polygon",
}

export const polygonLineTypes = {
  POLYGON_LINE: "polygonLine",
  POLYGON_DOTTED_LINE_ONE: "polygonDottedLineOne",
  POLYGON_DOTTED_LINE_TWO: "polygonDottedLineTwo",
  POLYGON_DOTTED_LINE_THREE: "polygonDottedLineThree",
};


export const SiteIconTypes = {
  PIN:'pin',
  TRIANGLE:'triangle',
  RECTANGLE:'rectangle',
  CIRCLE:'circle',
  TOWER:'tower',
  LOCATION:'location',
};

export const SiteUploadIcons = {
  [SiteIconTypes.PIN]: <PinMarkerIcon/>,
  [SiteIconTypes.TRIANGLE]: <TriangleMarkerIcon/>,
  [SiteIconTypes.RECTANGLE]: <RectangleMarkerIcon/>,
  [SiteIconTypes.CIRCLE]: <CircleMarkerIcon/>,
  [SiteIconTypes.TOWER]: <TowerMarkerIcon/>,
  [SiteIconTypes.LOCATION]: <LocationMarkerIcon/>,
  [polygonLineTypes.POLYGON_LINE]: <PolygonLine />,
  [polygonLineTypes.POLYGON_DOTTED_LINE_ONE]: <PolygonDottedLineOne/>,
  [polygonLineTypes.POLYGON_DOTTED_LINE_TWO]: <PolygonDottedLineTwo/>,
  [polygonLineTypes.POLYGON_DOTTED_LINE_THREE]: <PolygonDottedLineThree/>,
};

export const Modules = {
  SUPPLY_BEST_OPERATOR:'supplyBestOperator',
  SUPPLY_OPERATOR_PERFORMANCE:'supplyOperatorPerformance',
  DEMAND:'demand',
  CAPACITY:'capacity',
  SITES_EDOTCO:'sitesEdotco',
  SITES_OPERATOR:'sitesOperator',
  SITES_PROPOSED:'sitesProposed',
  MARKET_SHARE_TOP:'marketShareTop',
  MARKET_SHARE_OPERATOR:'marketShareOperator',
  IBS_BEST:'ibsBest',
  IBS_OPERATOR:'ibsOperator',
};
export const Names_For_Filter_OPs = {
  DEMAND:'Demand',
  SUPPLY:'Supply',
  SUPPLY_BEST_OPERATOR:"Best Operator",
  CAPACITY:'Capacity',
  SITES:'Sites',
  EC_SITES: "E.Co Sites",
  OPERATOR_SITES: "Operator Sites",
  SUPPLY_OPERATOR_PERFORMANCE:"Operator Performance",
  IBS:"IBS",
  IBS_BEST_OPERATOR:"Best Operator",
  IBS_OPERATOR_PERFORMANCE:"Operator Performance",
  PROPOSED_TENANTS: "Proposed Tenants",
  EXISTING_TENANTS:"Existing Tenants",
  MARKET_SHARE: 'Market Share',
  OP_MARKET_SHARE: 'Operator Market Share',
  TOP_MARKET_SHARE: 'Top Market Share',
};

export const Sections = {
  CAPACITY:'Capacity',
  OP_SITES: 'OperatorSites',
  SUPPLY_OPERATOR_PERFORMANCE: 'SupplyOperatorPerformance',
  SUPPLY_BEST_OPERATOR: 'SupplyBestOperator',
  DEMAND: 'Demand',
  SITE_ECO_EXISTING_TENANTS:'SiteECOExistingTenants',
  SITE_ECO_PROPOSED_TENANTS:'SiteECOProposedTenants',
  BEST_IBS: 'Best_IBS',
  IBS: 'IBS',
  OP_MARKET_SHARE: 'OPMarketShare',
  TOP_MARKET_SHARE: 'TopMarketShare'
}

export const webMapDownloadFunctions = {
  sitesEdotco: filterEdotcoSiteTowers,
  sitesOperator: filterOperatorSiteTowers,
  sitesProposed: filterProposedEdotcoTowers,
  capacity: getCapacityGeohashes,
  ibsBest: getBestOptrIBSMapData,
  ibsOperator: getOptrIBSMapData,
  supplyBestOperator: getBestOperatorGeohashes,
  supplyOperatorPerformance: getCustomOperatorGeohashes,
};

export const DOWNLOAD_ANONYMIZE_LEVELS = {
  [Modules.SUPPLY_BEST_OPERATOR]: {
    levelOne: Names_For_Filter_OPs.SUPPLY,
    levelTwo: Names_For_Filter_OPs.SUPPLY_BEST_OPERATOR,
  },
  [Modules.SUPPLY_OPERATOR_PERFORMANCE]: {
    levelOne: Names_For_Filter_OPs.SUPPLY,
    levelTwo: Names_For_Filter_OPs.SUPPLY_OPERATOR_PERFORMANCE,
  },
  [Modules.DEMAND]: { levelOne: Names_For_Filter_OPs.DEMAND },
  [Modules.CAPACITY]: { levelOne: Names_For_Filter_OPs.CAPACITY },
  [Modules.SITES_EDOTCO]: {
    levelOne: Names_For_Filter_OPs.SITES,
    levelTwo: "E.Co Sites",
    levelThee: "Existing Tenants",
  },
  [Modules.SITES_OPERATOR]: {
    levelOne: Names_For_Filter_OPs.SITES,
    levelTwo: "Operator Sites",
  },
  [Modules.SITES_PROPOSED]: {
    levelOne: Names_For_Filter_OPs.SITES,
    levelTwo: "E.Co Sites",
    levelThee: "Proposed Tenants",
  },
  [Modules.MARKET_SHARE_TOP]: {
    levelOne: 'Market Share',
    levelTwo: 'Top Market Share',
  },
  [Modules.MARKET_SHARE_OPERATOR]: {
    levelOne: "Market Share",
    levelTwo: "Operator Market Share",
  },
  [Modules.IBS_BEST]: {
    levelOne: Names_For_Filter_OPs.IBS,
    levelTwo: Names_For_Filter_OPs.IBS_BEST_OPERATOR,
  },
  [Modules.IBS_OPERATOR]: {
    levelOne: Names_For_Filter_OPs.IBS,
    levelTwo: Names_For_Filter_OPs.IBS_OPERATOR_PERFORMANCE,
  },
};